@if (auth.hasAll('RIGHT_CS_SYS_HELP_READ_DOCUMENTATION') && target) {
  <a hisImage="LINK_EXTERN" class="documentationLink" target="_blank"
	href="../../pages/cs/sys/portal/documentation/documentation.faces?
	navigationPosition=documentation&amp;site={{target}}"
  title="{{'common.openInNewWindow'|hisUi}}: {{'cs.sys.co.cc.export.help_6'| hisUi}} {{title | hisUi}}">{{'de.his.portal.doku' | hisUi}}</a>
}
